import PropTypes from "prop-types";
import { Container, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';


export default function ControlPageDescription({ pageDescription, className }) {
    if (!pageDescription) {
        pageDescription = "페이지 정보 없음";
    };

    return (
        <Container sx={{ p: 1 }} className={className} maxWidth="lg">
            <Grid container>
                <Typography variant="h3">{pageDescription}</Typography>
            </Grid>
        </Container>
    );
};
   
ControlPageDescription.propTypes = {
    pageDescription: PropTypes.string,
    className: PropTypes.string
};